import React from 'react'
import LoginForm from './LoginForm'
// import LoginIlustration from './LoginIlustration'
import LoginIllustrationV1 from './LoginIllustrationV1'
import './Login.css'

const Login = ({ location }) => {
  const { from } = location.state || { from: { pathname: '/main' } }
  return (
    <div className="login">
      <LoginForm redirect={from} />
      {/* <LoginIlustration /> */}
      <LoginIllustrationV1 />
    </div>
  )
}


export default Login



// WEBPACK FOOTER //
// ./src/components/login/Login.js